import axios from 'axios';
import store from '../index';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const state = {
	form: {
		productData: '',
		productType: [],
		dataType: [],
	},
};

const getters = {
	getForm: state => {
		return state.form;
	},
};

const actions = {
	FetchForm: async (context, data) => {
		console.log('cazzo', data);
		context.commit('form', data);
	},
};

const mutations = {
	setForm: async (state, value) => {
		state.form = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
